import React from "react";
import { Modal } from "antd";
import PowerVsLoadBoard from "./PowerVsLoadBoard";

interface PowerVsLoadModalProps {
  isOpen: boolean;
  onClose: () => void;
  infrastructureName: string;
  locationId: string;
  locationName: string;
  infrastructureType: string;
}

const PowerVsLoadModal: React.FC<PowerVsLoadModalProps> = ({
  isOpen,
  onClose,
  locationId,
  locationName,
  infrastructureName,
  infrastructureType,
}) => {
  return (
    <Modal
      title={`Power Vs Load for ${infrastructureName}`}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1200}
    >
      <PowerVsLoadBoard
        locationId={locationId}
        locationName={locationName || ""}
        infrastructureName={infrastructureName}
        infrastructureType={infrastructureType}
      />
    </Modal>
  );
};

export default PowerVsLoadModal;
